module.exports = __webpack_public_path__ + "static/media/pulsifi.32e2790b.png";